import React from "react";
import {Col, Layout, Row} from "antd";
import {PATH} from "../../config";
import {NavLink} from "react-router-dom";
import DiscoveryFilter from "./DiscoveryFilter";
import DiscoveryItems from "./DiscoveryItems";

const {Content} = Layout;

const DiscoveryRecently = () => {

    const DefaultAvatar = PATH+'avatar.png';
    const AvatarBG = PATH+'avatarBG.png';

    return (
        <div className="container mx-auto pt-162 min-h-calc-head h-full">
            <Layout className="bg-transparent h-full">
                <Content className="pt-8 pb-8 pl-10 pr-10 sm:pr-10">
                    <DiscoveryFilter />
                     
                    <DiscoveryItems title="Recently Created Metahus" type="recent" limit="48" image="recently.svg"/>
                     
                </Content>
            </Layout>
        </div>
    )
}

export default DiscoveryRecently;